import type { FC } from 'react';
import { Box, useTheme } from '@mui/material';

import type { DetailedFollowUpTicket } from 'src/types/followUp';

import { styles } from 'src/components/followUp/TicketOverviewPage/TicketDetail/ticketDetail.styles';

const NpsScoreBox: FC<{
  ticket: DetailedFollowUpTicket;
}> = ({ ticket }) => {
  const theme = useTheme();

  return (
    <Box
      sx={[
        {
          ...styles.npsScoreBox(theme),
        },
        ticket?.npsScore !== undefined && ticket.npsScore >= 9
          ? styles.npsScoreBoxPromoter(theme)
          : {},
        ticket?.npsScore !== undefined && ticket.npsScore <= 6
          ? styles.npsScoreBoxDetractor(theme)
          : {},
      ]}
    >
      {ticket?.npsScore}
    </Box>
  );
};

export default NpsScoreBox;
